import { Reveal } from "./Reveal";

const PHOTOS = [
  { src: "/gallery/himt-college-campus.png", caption: "frantiger labs- GTM strategy workshop", span: "lg:col-span-7", ratio: "aspect-[16/10]" },
  { src: "/gallery/g5.webp", caption: "frantiger HQ- Demo day", span: "lg:col-span-5", ratio: "aspect-[16/10]" },
  { src: "/gallery/g1.jpg", caption: "Campus Welcome — Envoy Kit Handover", span: "lg:col-span-4", ratio: "aspect-[4/3]" },
  { src: "/gallery/g2.jpg", caption: "Strategy Sprint — Lab Session", span: "lg:col-span-4", ratio: "aspect-[4/3]" },
  { src: "/gallery/g3.jpg", caption: "Builder Floor — Computer Lab Cohort", span: "lg:col-span-4", ratio: "aspect-[4/3]" },
  { src: "/gallery/g7.webp", caption: "Cohort Table — Weekly War Room", span: "lg:col-span-7", ratio: "aspect-[16/10]" },
  { src: "/gallery/g8.webp", caption: "frantiger HQ — The Lounge Wall", span: "lg:col-span-5", ratio: "aspect-[16/10]" },
  { src: "/gallery/g9.webp", caption: "Demo Day — Founder Stalls & Showcase", span: "lg:col-span-4", ratio: "aspect-[4/3]" },
  { src: "/gallery/g6.webp", caption: "Heads-Down — Sprint Floor Build", span: "lg:col-span-4", ratio: "aspect-[4/3]" },
  { src: "/gallery/g10.webp", caption: "Classroom Visit — First Ideation Sprint", span: "lg:col-span-4", ratio: "aspect-[4/3]" },
  { src: "/gallery/g15.webp", caption: "Community night - Entrepreneurship meetup", span: "lg:col-span-7", ratio: "aspect-[16/10]" },
  { src: "/gallery/g14.jpg", caption: "Partner Floor — Ecosystem Alliance", span: "lg:col-span-5", ratio: "aspect-[16/10]" },
  { src: "/gallery/g11.webp", caption: "Founder Dinner — Ecosystem Meetup", span: "lg:col-span-4", ratio: "aspect-[4/3]" },
  { src: "/gallery/g12.jpg", caption: "Knowledge++ — Team Huddle at HQ", span: "lg:col-span-4", ratio: "aspect-[4/3]" },
  { src: "/gallery/g13.webp", caption: "Campus Crew — #iamfrantiger Day", span: "lg:col-span-4", ratio: "aspect-[4/3]" },
];

const Gallery = () => (
  <section id="gallery" className="bg-white py-24 lg:py-32 border-b border-[#E2E8F0]">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
          <div>
            <span className="font-mono-x text-xs uppercase tracking-[0.25em] text-[#0055FF]">
              / ON THE GROUND
            </span>
            <h2 className="mt-5 font-display font-bold tracking-tight text-2xl sm:text-3xl lg:text-4xl text-[#0A0D14] leading-tight">
              Real campuses. Real rooms.{" "}
              <span className="font-serif-accent text-[#0055FF]">Real builders.</span>
            </h2>
          </div>
          <p className="text-sm text-[#64748B] max-w-sm leading-relaxed">
            Scenes from frantiger campus visits, lab sessions and the HQ war room —
            this is what the network looks like up close.
          </p>
        </div>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-6" data-testid="campus-gallery-grid">
        {PHOTOS.map((p, i) => (
          <Reveal key={p.src} delay={(i % 3) * 0.08} className={`col-span-1 md:col-span-1 ${p.span}`}>
            <figure
              data-testid={`gallery-photo-${i + 1}`}
              className="group relative border border-[#0055FF]/20 hover:border-[#0055FF] transition-colors overflow-hidden"
            >
              <div className={`overflow-hidden ${p.ratio}`}>
                <img
                  src={p.src}
                  alt={p.caption}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
              </div>
              <figcaption className="flex items-center justify-between px-4 py-3 bg-[#0A0D14]">
                <span className="font-mono-x text-[10px] uppercase tracking-[0.18em] text-white/75">
                  {p.caption}
                </span>
                <span className="font-mono-x text-[10px] text-[#0055FF]">{String(i + 1).padStart(2, "0")}</span>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Gallery;
